import React from "react";
import { formatINRFull } from "@/lib/format";

const BUCKETS = ["current", "1-30", "31-60", "61-90", "90+"];
const CATEGORIES = ["principal", "interest", "fee", "other", "gst"];

export const AgeingLedger = ({ ageing, prefix }) => (
  <table className="report-table ageing-ledger" data-testid={`${prefix}-ageing-ledger`}>
    <thead><tr><th>Ageing</th>{CATEGORIES.map(c => <th key={c}>{c}</th>)}<th>Total</th></tr></thead>
    <tbody>{BUCKETS.map(bucket => {
      const row = ageing[bucket] || {};
      return <tr key={bucket} data-testid={`${prefix}-ageing-${bucket}`}>
        <td data-label="Ageing">{bucket}</td>
        {CATEGORIES.map(c => <td key={c} data-label={c} data-testid={`${prefix}-ageing-${bucket}-${c}`}>{formatINRFull(row[c] ?? 0)}</td>)}
        <td data-label="Total" data-testid={`${prefix}-ageing-${bucket}-total`}><b>{formatINRFull(CATEGORIES.reduce((s, c) => s + (row[c] || 0), 0))}</b></td>
      </tr>;
    })}</tbody>
  </table>
);